import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getAttachment } from 'utils/attachment';


const ProductImg = ({product}) => {
    const [img, setImg] = useState([]);
    const [play, setPlay] = useState(false);

    useEffect(() => {
        if (product?.images) {
            setImg(product.images);
            setPlay(true)
        }
    }, [product]);

    return (
        <Carousel 
            autoPlay={play} 
            swipeable={true} 
            showArrows={false}
            showThumbs={false} 
            showStatus={false}
            infiniteLoop={true}
            animationHandler='fade'
            className={"wrapperCarousel"}
        >
            {img?.map(({id}, index) => <div key={index} className={'img-carousel'}>
                <img src={getAttachment(id)} alt="#"/>
            </div>)}
        </Carousel>
    )
}

export default ProductImg;